import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CTA_COLOR_BY_NAME } from 'constants/colors';
import * as actions from './actions';

export class CallToAction extends PureComponent {
  ctaColor() {
    return CTA_COLOR_BY_NAME[this.props.color] || CTA_COLOR_BY_NAME.default;
  }

  render() {
    const { action, children, color, extraClass, ...extraProps } = this.props;

    const Component = actions[action];

    if (!Component || !children) {
      return null;
    }

    return (
      <Component {...extraProps} className={classNames(this.ctaColor(), extraClass)}>
        {children}
      </Component>
    );
  }
}

CallToAction.propTypes = {
  action: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.oneOf(Object.keys(CTA_COLOR_BY_NAME)),
  extraClass: PropTypes.string,
};
